module.exports = __webpack_public_path__ + "static/img/gptModel22.f9d8ffd1.png";